import styled from '@emotion/styled';
import { getLinkPropsForUrl } from '../../../navigation/getLinkPropsForUrl';
import { RouterLink } from '../link/RouterLink';
import FooterSocialsSection from './FooterSocialsSection';
import {
	ContentWrap,
	Css,
	ITheme,
	IUrlLinkItem,
	Responsive,
} from '../../../ui';
import { ISocialLinksProps } from '../social-links/SocialLinks';

const FULL_YEAR = new Date().getFullYear();

export interface IFooterFinePrintProps {
	links: IUrlLinkItem[];
	socialLinks?: ISocialLinksProps;
}

export function FooterFinePrint({ links, socialLinks }: IFooterFinePrintProps) {
	const isMobileXL = Responsive.useMatchesBreakpoint('mobileXL');

	return (
		<FooterFinePrintWrap>
			<StyledContentWrap>
				<strong>{`Houston Airport System \u00A9 ${FULL_YEAR}`}</strong>
				<FooterFinePrintLinks>
					{links?.map((link) => (
						<RouterLink key={link.key} {...getLinkPropsForUrl(link.url)}>
							{link.title}
						</RouterLink>
					))}
				</FooterFinePrintLinks>
				{isMobileXL && socialLinks && (
					<FooterSocialsSection socialLinks={socialLinks} />
				)}
			</StyledContentWrap>
		</FooterFinePrintWrap>
	);
}

const FooterFinePrintWrap = styled.div<{}, ITheme>`
	padding: ${Css.pxToRem(24)} 0;

	strong {
		@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
			margin-top: ${Css.pxToRem(32)};
		}
	}
`;

const StyledContentWrap = styled(ContentWrap)`
	display: flex;
	justify-content: space-between;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		flex-direction: column-reverse;
	}
`;

const FooterFinePrintLinks = styled.div<{}, ITheme>`
	display: flex;
	gap: ${Css.pxToRem(24)};

	a {
		text-decoration: none;
		font-weight: 400;
		color: ${(props) => props.theme.color.onSecondary};

		&:hover {
			text-decoration: underline;
		}
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: grid;
		grid-template-columns: repeat(1, 1fr);
		gap: ${Css.pxToRem(16)};
	}
`;
